import { clsx, type ClassValue } from 'clsx';

/**
 * 合并 className 的工具函数
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}